export default "__VITE_ASSET__LTWOAGya__"